const MISSION_TARGETS = {
  'level-01': { tier: 'training', targetClearSeconds: 35, cleanClearSeconds: 24, intendedAlerts: 0, identity: 'movement, cover, first flag' },
  'level-02': { tier: 'training', targetClearSeconds: 48, cleanClearSeconds: 34, intendedAlerts: 1, identity: 'rescue route and escort' },
  'level-03': { tier: 'training', targetClearSeconds: 50, cleanClearSeconds: 36, intendedAlerts: 1, identity: 'sabotage then extraction' },
  'level-04': { tier: 'midgame', targetClearSeconds: 54, cleanClearSeconds: 40, intendedAlerts: 1, identity: 'lane timing and escape' },
  'level-05': { tier: 'midgame', targetClearSeconds: 68, cleanClearSeconds: 52, intendedAlerts: 2, identity: 'split relay routing' },
  'level-06': { tier: 'midgame', targetClearSeconds: 66, cleanClearSeconds: 50, intendedAlerts: 2, identity: 'guarded sabotage loop' },
  'level-07': { tier: 'midgame', targetClearSeconds: 70, cleanClearSeconds: 54, intendedAlerts: 2, identity: 'bridge pressure and route commitment' },
  'level-08': { tier: 'finale', targetClearSeconds: 72, cleanClearSeconds: 56, intendedAlerts: 2, identity: 'late rescue under cross pressure' },
  'level-09': { tier: 'finale', targetClearSeconds: 82, cleanClearSeconds: 64, intendedAlerts: 3, identity: 'three objective sweep' },
  'level-10': { tier: 'finale', targetClearSeconds: 86, cleanClearSeconds: 68, intendedAlerts: 3, identity: 'final runway breakout' },
};

function countObjectiveSteps(level) {
  if (level.objectiveType === 'rescue') {
    return 2;
  }

  if (level.objectiveType === 'sabotage') {
    return 2;
  }

  if (level.objectiveType === 'multi-sabotage') {
    return (level.targets?.length ?? 0) + 1;
  }

  return 1;
}

export function getMissionPressure(level) {
  const enemies = level.enemies ?? [];
  const terrainSlowZones = (level.terrains ?? [])
    .filter((terrain) => (terrain.speedMultiplier ?? 1) < 1).length;
  const enemyPressure = enemies.reduce((pressure, enemy) => {
    const visionPressure = (enemy.visionRange ?? 150) / 150;
    const healthPressure = enemy.health ?? 1;

    return pressure + visionPressure + healthPressure * 0.55;
  }, 0);

  return {
    enemyCount: enemies.length,
    obstacleCount: level.obstacles?.length ?? 0,
    objectiveSteps: countObjectiveSteps(level),
    terrainSlowZones,
    pressureScore: Math.round(enemyPressure + terrainSlowZones * 0.7 + countObjectiveSteps(level) * 0.9),
  };
}

export function getMissionTarget(level) {
  return {
    ...MISSION_TARGETS[level.id],
    ...getMissionPressure(level),
  };
}

export function getMissionTargets(levels) {
  return levels.map((level) => ({
    id: level.id,
    name: level.name,
    ...getMissionTarget(level),
  }));
}
